import {API_URL, apiGet} from '../api'

// GET /v3/admin/key/:id/probe — 키 하나로 온디맨드 사이클 1회를 돌리고 거래소 응답 바디를 원본 그대로 받는다.
// 요약 판정이 필요한 경우가 아니라 "어느 엔드포인트가 무슨 코드로 거절했나"를 봐야 할 때 쓴다.
//
// withOrders=true는 orders phase까지 돌린다. 이 phase는 19개 거래소 중 16개에서 가져온 주문을
// 실제로 저장하므로 기본값은 false다. 응답은 raw 바디라 수십 KB까지 나온다.
export const getKeyProbe = async (id: string, withOrders: boolean) => {
    return await apiGet(API_URL, `admin/key/${id}/probe${withOrders ? '?with_orders=true' : ''}`)
}
